<template lang="pug">
	CompanyDetail(:id="$auth.companyId()", v-if="$auth.hasAccessToCompanyProfile()", v-bind="{ ...($props || {}), ...($route.params || {}) }")
</template>

<script>
	import CompanyDetail from './Detail.vue';

	export default {
		translationCategory: 'company.CompanyProfile',
		name: 'company-profile',
		components: { CompanyDetail },
		props: ['activeTab'],
		mounted() {
			if (__DEBUG__)
				window.companyProfileInitiate = this;
		}
	};
</script>
 